import * as React from "react";
import { withStyles, Theme } from "@material-ui/core/styles";
import { NoHistoryIcon } from "../../../assets"


interface EmptyPageProps {
  message:string;
  classes: any;
}

const styles: any = (theme: Theme) => ({
  container:{
    backgroundColor:"#F4F7FC",
    borderRadius:"10px",
    display:"flex",
    alignItems:"center",
    justifyContent:"center",
    height:"100%",
    textAlign:"center",
    width: "100%",
    padding: "20px"
  },
  text:{
    fontFamily: "Roboto",
    color:"#627995",
    marginTop:24
  }
})

const  EmptyPage : React.FC<EmptyPageProps>=(props)=> {   
  const classes = props.classes

  return (
    <div className={classes.container}>
      <div>
        <NoHistoryIcon/>
        <div className={classes.text}>{props.message}</div>
      </div>
    </div>
  );
}

export default withStyles(styles)(EmptyPage) 


// WEBPACK FOOTER //
// ./src/pages/next-action/EmptyPage/index.tsx